const ThreadPresenceBar = ({ presentUuids = [] }) => {
  if (presentUuids.length === 0) return null;

  const MAX_SHOW = 4;
  const visible = presentUuids.slice(0, MAX_SHOW);
  const overflow = presentUuids.length - MAX_SHOW;

  return (
    <div className="flex items-center gap-1.5 px-3 py-1.5">
      <div className="flex -space-x-1.5">
        {visible.map((uuid) => (
          <div
            key={uuid}
            className="w-5 h-5 rounded-full bg-velBlue/20 border border-white dark:border-gray-800 flex items-center justify-center text-[9px] font-medium text-velBlue"
            title={uuid}
          >
            {uuid.slice(0, 2).toUpperCase()}
          </div>
        ))}
        {overflow > 0 && (
          <div className="w-5 h-5 rounded-full bg-gray-200 dark:bg-gray-600 border border-white dark:border-gray-800 flex items-center justify-center text-[9px] font-medium text-mutedText">
            +{overflow}
          </div>
        )}
      </div>
      <span className="text-[11px] font-light text-mutedText">
        {presentUuids.length === 1
          ? "1 other viewing"
          : `${presentUuids.length} others viewing`}
      </span>
    </div>
  );
};

export default ThreadPresenceBar;
